import React from 'react';
import { Link } from 'react-router-dom';

const IconArrow = ({ className }) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
  </svg>
);

function Branches() {
  const branches = [
    {
      name: 'HEAD OFFICE',
      address: 'Pioneer House Kimathi Street',
      building: '7th Floor, Suite 4',
      phone: '0727 22 66 44',
      email: 'info@tglcredit.co.ke',
    },
    {
      name: 'Eldoret Office',
      address: 'Kenyatta Avenue',
      building: 'The Anchor Building, 2nd floor  room 206',
      phone: '0718 590 357',
      email: 'info@tglcredit.co.ke',
    },
    {
      name: 'Nakuru Office',
      address: 'Tom Mboya Street',
      building: 'Jennifer Riria Hub, Ground Floor',
      phone: '0113 48 77 37',
      email: 'info@tglcredit.co.ke',
    },
  ];

  return (
    <div className="bg-gray-50 py-16 sm:py-20 bg-[radial-gradient(circle_at_center,rgba(47,73,140,0.05)_0%,transparent_70%)]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="bg-primary-blue text-white rounded-lg py-8 px-6 text-center mb-12 animate-fade-up shadow-lg">
          <h1 className="text-3xl sm:text-4xl font-inter font-bold">Our Branches</h1>
          <p className="text-lg font-inter mt-2">
            Visit us at one of our convenient locations across the region.
          </p>
        </div>

        {/* Content */}
        <div className="mb-12 animate-fade-in">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {branches.map((branch, index) => (
              <div
                key={branch.name}
                className="group relative bg-white/95 backdrop-blur-md p-8 rounded-lg shadow-md hover:shadow-xl hover:-translate-y-1 hover:scale-105 hover:rotate-1 transition-all duration-300 border-2 border-primary-blue/20 animate-fade-up"
                style={{ animationDelay: `${0.1 + index * 0.1}s` }}
              >
                <h3 className="text-xl font-inter font-extrabold text-primary-blue mb-3 tracking-tight">{branch.name}</h3>
                <div className="flex items-center text-[14px] font-inter font-medium text-gray-600 mb-2">
                  <svg className="w-6 h-6 text-primary-blue mr-3 group-hover:text-primary-red group-hover:scale-110 transition-all duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  {branch.address}
                </div>
                <div className="flex items-center text-[14px] font-inter font-medium text-gray-600 mb-2">
                  <svg className="w-6 h-6 text-primary-blue mr-3 group-hover:text-primary-red group-hover:scale-110 transition-all duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                  {branch.building}
                </div>
                <div className="flex items-center text-[14px] font-inter font-medium text-gray-600 mb-2">
                  <svg className="w-6 h-6 text-primary-blue mr-3 group-hover:text-primary-red group-hover:scale-110 transition-all duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  {branch.phone}
                </div>
                <div className="flex items-center text-[14px] font-inter font-medium text-gray-600">
                  <svg className="w-6 h-6 text-primary-blue mr-3 group-hover:text-primary-red group-hover:scale-110 transition-all duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  {branch.email}
                </div>
                <div className="absolute inset-0 bg-gradient-to-br from-primary-blue/10 to-primary-blue/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-lg" />
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center animate-fade-up" style={{ animationDelay: '0.4s' }}>
          <Link
            to="/contact-us"
            className="inline-flex bg-gradient-to-r from-primary-blue to-primary-blue-dark text-white font-inter font-medium px-6 py-3 rounded-lg hover:bg-[--primary-red] hover:shadow-xl hover:shadow-[--primary-red]/30 hover:scale-110 transition-all duration-300 uppercase tracking-wide text-sm focus:ring-2 focus:ring-[--primary-blue] focus:ring-offset-2"
            aria-label="Get in Touch"
          >
            <span className="flex items-center">
              Get in Touch
              <span className="ml-2 rounded-full bg-white border border-[--primary-blue] group-hover:border-[--primary-red] p-1 flex items-center justify-center">
                <IconArrow className="w-3 h-3 group-hover:translate-x-1 transition-transform duration-300 text-[--primary-blue] group-hover:text-[--primary-blue]" />
              </span>
            </span>
          </Link>
        </div>
      </div>
      <style>
        {`
          @keyframes fade-up {
            from { opacity: 0; transform: translateY(15px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .animate-fade-up {
            animation: fade-up 0.6s ease-out forwards;
            willChange: transform, opacity;
          }
          @keyframes fade-in {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          .animate-fade-in {
            animation: fade-in 0.6s ease-out forwards;
            willChange: opacity;
          }
          .backdrop-blur-md {
            backdrop-filter: blur(8px);
            -webkit-backdrop-filter: blur(8px);
          }
          @media (prefers-reduced-motion: reduce) {
            .animate-fade-up, .animate-fade-in, .hover\\:scale-105, .hover\\:shadow-lg, .hover\\:shadow-xl, .hover\\:rotate-1, .hover\\:scale-110, .group-hover\\:scale-x-100, .group-hover\\:opacity-100, .group-hover\\:translate-x-1, .group-hover\\:scale-110 {
              animation: none !important;
              transform: none !important;
              opacity: 1 !important;
              transition: none !important;
            }
          }
          :root {
            --primary-blue: #2F498C;
            --primary-blue-dark: #1e355f;
            --primary-red: #843345;
            --primary-red-dark: #672737;
          }
          .bg-primary-blue {
            background-color: var(--primary-blue);
          }
          .bg-primary-blue-dark {
            background-color: var(--primary-blue-dark);
          }
          .bg-primary-red {
            background-color: var(--primary-red);
          }
          .text-primary-blue {
            color: var(--primary-blue);
          }
          .text-primary-red {
            color: var(--primary-red);
          }
          .text-primary-red-dark {
            color: var(--primary-red-dark);
          }
          .hover\\:bg-primary-blue:hover {
            background-color: var(--primary-blue);
          }
          .hover\\:bg-primary-red:hover {
            background-color: var(--primary-red);
          }
          .hover\\:text-primary-red:hover {
            color: var(--primary-red);
          }
          .hover\\:shadow-primary-red\\/30:hover {
            --tw-shadow-color: rgba(132, 51, 69, 0.3);
            --tw-shadow: var(--tw-shadow-colored);
          }
          .border-primary-blue\\/20 {
            border-color: rgba(47, 73, 140, 0.2);
          }
          .group-hover\\:text-primary-red:hover {
            color: var(--primary-red);
          }
          .group-hover\\:border-[--primary-red]:hover {
            border-color: var(--primary-red);
          }
          .focus\\:ring-[--primary-blue]:focus {
            --tw-ring-color: var(--primary-blue);
          }
          .from-primary-blue {
            --tw-gradient-from: var(--primary-blue);
            --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(47, 73, 140, 0));
          }
          .to-primary-blue-dark {
            --tw-gradient-to: var(--primary-blue-dark);
          }
        `}
      </style>
    </div>
  );
}

export default Branches;